
import { DateFormatPipe } from '../common/pipes/DateFormatPipe';
import { VehicleReservationSearchAgencyResult } from './../models/VehicleReservationSearchAgencyResult';
import { VehicleFeatureModel } from './Booking/VehicleReservationCaseResult';

import { VehicleSearchTypeEnum } from './enums/VehicleSearchTypeEnum';
import { EvaluationSummaryModel } from './Evaluation/EvaluationSummaryModel';
import { CampaignsReservationCaseModel, LstPolicyReservationCaseModel, MembershipModel } from './VehicleReservationCaseDetailsModel';

export class Vehicle {
  classSearch?: boolean;
  makeModelYearSearch?: boolean;
  vehicleSearch?: boolean;
  searchAvailableVehicleFilterType?;
  membershipModel?: any;
  shownPricesIncludeTax?:boolean;
  includeMandatoryCharges?:boolean;


  constructor(model: VehicleReservationSearchAgencyResult, type,) {


    /*   this.vehiclePrice=40;
      this.periodInDays=3; */
    this.totalOutsideWorkingHoursCharge = model.totalOutsideWorkingHoursCharge;

    this.agencyName = model.agencyName;
    this.agencyID = model.agencyID;
    this.vehicleLocation = model.locationName;
    this.evaluationSummary = model.evaluationSummary;
    this.makeModelYearName = model["makeModelYearName"];
    this.lstPolicyReservationCaseModel = model.lstPolicyReservationCaseModel;
    this.shownPricesIncludeTax = model.shownPricesIncludeTax;
    this.includeMandatoryCharges = model.includeMandatoryCharges;

    if(model.isAvailable!=null){
      this.isAvailable=model.isAvailable;
    }


    this.campaignsReservationCaseModel = model.campaignsReservationCaseModel;
    this.membershipModel2 = model.membershipModel2;

    this.customerFavouriteReservationID = model.customerFavouriteReservationID;
    this.searchAvailableVehicleFilterType = type;
    this.isFavorite = model.customerFavouriteReservationID != null ? true : false;
    let _feature: VehicleFeatureModel;
    _feature = model.featuresModel;
    this.pricingRuleID = model.pricingRuleID;
    this.vehicleRentalNumber = model.totalRentals;
    this.vehicleName = model.makeModelYear;
    this.vehicleClass = model.vehicleClassName;
    //this.vehicleImage = 'assets/img/car.png';
    this.hasAirConditions = model.hasAirConditions;
    this.vehicleLocation = model.locationName;
    this.vehicleTotalReviews = 0;
    this.plateNumber = model.plateNumber;
    this.vehiclePrice = model.rentalUnitPrice;
    this.periodInDays = model.durationInDays;
    this.durationUnitName = model.durationUnitName != null ? model.durationUnitName.replace('-', ' ') : '';
    this.makeID = model.makeID;
    this.classID = model.classID;
    this.modelID = model.modelID;
    this.year = model.year;
    this.vehicleID = model.vehicleID;
    this.contractTypeID = 1;
    this.rateTypeID = model.rateTypeID;

    this.campaignID = model.campaignID;
    this.membershipID = model.membershipID;
    this.membershipModel = model.membershipModel;

    //this.membershipName = model.membershipName;


    //For My Favorites

    this.pickupLocationID = model['pickupLocationID']
    this.dropOffLocationID = model['dropOffLocationID']
    this.dropOffLocationTypeID = model['dropOffLocationTypeID']
    this.fromAgencyName = model['fromAgencyName'];
    this.toAgencyName = model['toAgencyName'];
    //end for my Favorite


    //Class Search
    if (type == VehicleSearchTypeEnum.classSearch) {

      //this.vehicleColors = JSON.parse(model.vehicleColors + "");

      //this.vehicleColors=model.vehicleColors;
      this.vehicleGearTypeList = _feature.gearBox.map(a => a.gearBoxName);
      this.vehiclePetrolTypeList = _feature.fuel.map(a => a.fuelName);
      this.vehiclePassengersNumberList = _feature.passengers.map(a => a.passengersName + '');
      this.vehicleDoorsNumberList = _feature.numberOfDoors.map(a => a.numberOfDoorsName + '');
      this.vehicleClassList = _feature.vehicleType.map(a => a.vehicleTypeName);
      this.vehicleStorageList = _feature.storgeCapacity.map(a => a.storgeCapacityName);

    }
    else if (type == VehicleSearchTypeEnum.MakeModelYearSearch) {

      if(model.vehicleColors!=null&&model.vehicleColors!=""){
        this.vehicleColors = JSON.parse(model.vehicleColors + "");
      }


      this.vehicleGearTypeList = _feature.gearBox.map(a => a.gearBoxName);
      this.vehiclePetrolTypeList = _feature.fuel.map(a => a.fuelName);
      this.vehiclePassengersNumberList = _feature.passengers.map(a => a.passengersName + '');
      this.vehicleDoorsNumberList = _feature.numberOfDoors.map(a => a.numberOfDoorsName + '');
      this.vehicleClassList = _feature.vehicleType.map(a => a.vehicleTypeName);
      this.vehicleStorageList = _feature.storgeCapacity.map(a => a.storgeCapacityName);

    }
    else {

      this.vehicleColors = [model.extericColor];
      if (_feature != null) {
        this.vehicleGearType = _feature.gearBox != null ? _feature.gearBox[0].gearBoxName : '';
        this.vehiclePetrolType = _feature.fuel != null ? _feature.fuel[0].fuelName : '';
        this.vehiclePassengersNumber = _feature.passengers != null ? _feature.passengers[0].passengersName + '' : '';
        this.vehicleDoorsNumber = _feature.numberOfDoors != null ? _feature.numberOfDoors[0].numberOfDoorsName + '' : '';
        //this.vehicleClass=_feature.vehicleType[0]!=null?_feature.vehicleType[0].vehicleTypeName:'';
        this.vehicleStorage = _feature.storgeCapacity != null ? _feature.storgeCapacity[0].storgeCapacityName : '';
      }

      this.vehicleOdometer = model.odometerView;
      //For the demo take only one word
      /*         this.vehicleColors=[model.extericColor];
              this.vehicleGearType=_feature.GearBox[0].GearBoxName.split(' ')[0];;
              this.vehiclePetrolType=_feature.Fuel[0].FuelName.split(' ')[0];;
              this.vehiclePassengersNumber=_feature.Passengers[0].PassengersName;
              this.vehicleDoorsNumber=_feature.NumberOfDoors[0].NumberOfDoorsName;
              this.vehicleClass=_feature.VehicleType[0].VehicleTypeName.split(' ')[0];
              this.vehicleStorage=_feature.StorgeCapacity[0].StorgeCapacityName.split(' ')[0];
              this.vehicleOdometer=model.odometer; */
    }


    switch (type) {
      case VehicleSearchTypeEnum.classSearch:
        this.classSearch = true;
        break
      case VehicleSearchTypeEnum.MakeModelYearSearch:
        this.makeModelYearSearch = true;
        break
      case VehicleSearchTypeEnum.vehicleSearch:
        this.vehicleSearch = true;
        break
    }
    this.images = [{
      id: 1,
      url: "http://localhost:4200/assets/img/car.png"
    },
    {
      id: 2,
      url: "http://localhost:4200/assets/img/car2.png"
    },
    {
      id: 3,
      url: "http://localhost:4200/assets/img/car.png"
    },
    {
      id: 4,
      url: "http://localhost:4200/assets/img/tesla.jpg"
    }];





  }

  agencyID?: any;
  agencyName?: string;
  lstPolicyReservationCaseModel?: LstPolicyReservationCaseModel[];
  campaignsReservationCaseModel?: CampaignsReservationCaseModel;
  membershipModel2?:MembershipModel;
  id?: number;
  vehicleImage?: string;
  vehicleName?: string;
  vehicleOdometer?: number;
  vehicleColors?: string[];
  vehicleGearType?: string;
  vehicleConditionUnit?: boolean;
  vehiclePetrolType?: string;
  vehiclePassengersNumber?: string;
  vehicleDoorsNumber?: string;
  vehicleStorage?: string;
  vehicleLocation?: string;
  vehicleRentalNumber?: number;
  vehiclePrice?: number;
  vehicleRankNumber?: number;
  vehicleRankText?: string;
  vehicleTotalReviews?: number;
  vehiclePromotionName?: string;
  vehiclePromotions?: string[];
  vehicleDeposit?: string;
  vehicleClass?: string;
  hasPromotion?: boolean;
  hasAirConditions?: boolean;
  pricingRuleID?: string;
  vehicleGearTypeList?: string[];
  vehiclePetrolTypeList?: string[];
  vehiclePassengersNumberList?: string[];
  vehicleDoorsNumberList?: string[];
  vehicleClassList?: string[];
  vehicleStorageList?: string[];
  periodInDays?: number;
  images?: any[];
  plateNumber?: string;
  durationUnitName?: string;
  classID?: number;
  makeID?: number;
  modelID?: number;
  year?: number;
  vehicleID?: number;
  contractTypeID?: number;
  rateTypeID?: number;
  evaluationSummary?: EvaluationSummaryModel;
  makeModelYearName?: string;
  //#region View Properies (not backend data)
  isImageClicked?: boolean;
  isFavorite?: boolean;
  //#endregion

  //#region Campaign and membership
  campaignID?: string;
  membershipID?: string;
  //#endregion

  customerFavouriteReservationID?: string;

  //#region  Favorite needed variables
  pickupLocationID?: string;
  dropOffLocationID?: string;
  dropOffLocationTypeID?;
  fromAgencyName?;
  toAgencyName?;

  //#endregion
  totalOutsideWorkingHoursCharge?: number;
  isAvailable?:boolean=true;

}
